import React from 'react';
import { Text, View } from 'react-native';
import toolTipStyles from './Tooltip.styles';

interface TooltipProps {
  label: string;
}

const Tooltip: React.FC<TooltipProps> = ({ label }) => {
  const styles = toolTipStyles();
  return (
    <View style={styles.wrapper}>
      <View style={styles.container}>
        <Text style={styles.text}>{label}</Text>
      </View>
      <View style={styles.arrow} />
    </View>
  );
};

export default Tooltip;
